import { reactive } from '@vue/composition-api'
import i18n from "@/i18n";
export const getError = (error) => {
  const errorMessage = i18n.t("errors.api_error_try_again");

  if (error.name === "Fetch User") {
    return error.message;
  }

  if (!error.response) {
    console.error(`API ${error.config.url} not found`);
    return errorMessage;
  }
  if (process.env.NODE_ENV === "development") {
    console.error(error.response.data);
    console.error(error.response.status);
    console.error(error.response.headers);
  }
  if (error.response.data && error.response.data.errors) {
    return error.response.data.errors;
  }

  return errorMessage;
};

// Map backend validation/response messages to localized strings
export const mapBackendMessage = (message, $t) => {
  const map = {
    "The Routes between Stops field is required.": $t('routes.routes_between_stops_required'),
  };
  return map[message] || message;
};

export const adminProfileStore = reactive({
  id: '',
  name: '',
  avatar: '',
})

export const activationStore = reactive({
  isActivated: true,
})
